import React from "react"
import LandingHero from "./LandingHero"
import LandingNav from "./LandingNav"
// import LandingFindYourPlaceSection from "./LandingFindYourPlaceSection"
import LandingEventsSection from "./LandingEventsSection"
import LandingPrayerTestimonySection from "./LandingPrayerTestimonySection"
// import LandingPrayerDeclarationSection from "./LandingPrayerDeclarationSection"
// import LandingWordOfTheWeekSection from "./LandingWordOfTheWeekSection"
import LandingLocationsSection from "./LandingLocationsSection"
import LandingCtaSection from "./LandingCtaSection"
import LandingSermonsSection from "./LandingSermonsSection"
import LandingFooter from "./LandingFooter"

const LandingPage: React.FC = () => {
  return (
    <div className="bg-base-100">
      <LandingNav />
      <LandingHero />
      <LandingEventsSection />
      {/* <LandingWordOfTheWeekSection /> */}
      {/* <LandingFindYourPlaceSection /> */}
      <LandingCtaSection />
      {/* <LandingPrayerDeclarationSection /> */}
      <LandingPrayerTestimonySection />
      <LandingSermonsSection />
      <LandingLocationsSection />
      <LandingFooter />
    </div>
  )
}

export default LandingPage
